// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__e8mep","signatureBlock":"Footer_signatureBlock__kStjK","signature":"Footer_signature__36_le"};